<template>
    <div class="page-wrap" v-loading="loading">
        <div class="landing-shell">
            <img class="hero-img" :src="heroImg" alt="hero" />

            <section class="consent-block">
                <img class="step-label" :src="phoneLabelImg" alt="step label" />
                <div class="phone-input-wrap">
                    <input
                        v-model.trim="mobile"
                        class="phone-input"
                        type="tel"
                        maxlength="11"
                        inputmode="numeric"
                        placeholder="请填写手机号"
                    />
                </div>
                <div class="agree-row">
                    <span class="agree-icon">✓</span>
                    <span>
                        提交视为阅读和同意
                        <button class="rule-link" type="button" @click="openRulePage">《用户服务条款及隐私政策》</button>
                    </span>
                </div>
                <button class="confirm-btn" type="button" @click="onOpen">
                    <img class="confirm-gif" :src="receiveButtonImg" alt="登录领取" />
                </button>
            </section>

            <section class="below-content">
                <div class="benefits-wrap">
                    <img class="benefits-image" :src="memberBenefitsImg" alt="member benefits" />
                    <div class="price-line">资费： {{ priceText }}元/月（30天）</div>
                </div>
                <div class="rules-banner">
                    <img class="rules-banner-img" :src="rulesBgImg" alt="rules background" />
                    <div class="rules-banner-text">
                        <div class="rules-copy">
                            <p>活动对象：2G/3G/4G/5G手机用户</p>
                            <p>本页面仅供客户购买权益，非用于鉴权登录等其他服务。老人及未成年人请谨慎消费，敬请知悉！为了您的权益保障，请注意核实订购规则及订单详情，不要轻信陌生人通过网络、电话、短信告知的信息，谨防网络电话诈骗。</p>
                            <p>一、订购规则</p>
                            <p>1. 月月随心选产品（以下简称本产品）当前支持三网（移动、联通、电信）用户办理。</p>
                            <p>2. 同一用户仅限参与一次活动。用户授权签约开通服务后，可获赠最低4折品牌优惠购服务，用户有充分的时间确认是否订购该产品。中途如未取消，则默认您同意订购该产品，并在48小时内进行自动扣费。本产品资费49.9元，每30个自然日为一轮会员周期，订购成功后随即扣除当个会员周期费用。</p>
                            <p>3. 如无退订操作，本产品默认次月自动续订，最长自动续约周期为12个月（含开通当月）。每一轮会员周期开始当日0点起至当个周期最后一天0点将从会员绑定手机的支付宝账户中自动扣除当个周期会员费。</p>
                            <p>二、使用规则</p>
                            <p>1. 每个会员周期内用户可获得一次【热门APP会员】领取机会，若当个周期内未领取，领取机会将在周期最后一天23:59:59点自动失效。</p>
                            <p>2. 每个会员周期内用户可无限次使用我们的【优惠权益】。</p>
                            <p>三、会员退订</p>
                            <p>1. 本产品可随时退订，退订后当个周期可继续享用本产品权益至当个周期最后一天23:59:59点，次日起会员自动失效，不再继续扣费。</p>
                            <p>2. 如对活动有疑问或其他需求，请咨询在线客服。</p>
                        </div>
                    </div>
                </div>
                <button class="confirm-btn confirm-btn-bottom" type="button" @click="onOpen">
                    <img class="confirm-gif" :src="receiveButtonImg" alt="登录领取" />
                </button>
            </section>
            <div ref="bottomSentinel" class="confirm-spacer"></div>
        </div>

        <el-dialog title="用户服务条款及隐私政策" :visible.sync="privacyVisible" width="90%" top="10vh">
            <div class="dialog-content">
                <p>提交视为阅读和同意《用户服务条款及隐私政策》。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" round @click="privacyVisible = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ThirdPage',
    data() {
        return {
            loading: false,
            privacyVisible: false,
            mobile: '',
            buttonFixed: false,
            priceText: '49.8',
            alipayAppId: '',
            heroImg: require('@/assets/images/hero.png'),
            phoneLabelImg: require('@/assets/images/phone-label.gif'),
            receiveButtonImg: require('@/assets/images/receive-button.gif'),
            memberBenefitsImg: require('@/assets/images/member-benefits.png'),
            rulesBgImg: require('@/assets/images/rules-bg.png')
        }
    },
    mounted() {
        this.handleScroll = () => {
            const sentinel = this.$refs.bottomSentinel
            if (!sentinel) return
            const rect = sentinel.getBoundingClientRect()
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
            this.buttonFixed = rect.top <= viewportHeight - 80
        }
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        window.addEventListener('resize', this.handleScroll, { passive: true })
        this.$nextTick(() => this.handleScroll())
        this.fetchLandingConfig()
        this.fetchAlipayAppId()
    },
    beforeDestroy() {
        if (this.handleScroll) {
            window.removeEventListener('scroll', this.handleScroll)
            window.removeEventListener('resize', this.handleScroll)
        }
    },
    methods: {
        async fetchLandingConfig() {
            const domain = window.location.hostname
            if (!domain) return

            try {
                this.loading = true
                const urls = [
                    `https://zfbht.huiwu0811.com/common/landingConfig?domain=${encodeURIComponent(domain)}`
                ]

                for (const url of urls) {
                    try {
                        const resp = await fetch(url, { method: 'GET' })
                        const data = await resp.json()
                        const config = data && data.data ? data.data : {}
                        const price = config.pageBAmountYuan || config.price
                        if (resp.ok && price) {
                            this.priceText = price
                            return
                        }
                    } catch (e) {
                        // try next url
                    }
                }
            } catch (error) {
                console.error('获取落地页配置失败', error)
            } finally {
                this.loading = false
            }
        },
        async fetchAlipayAppId() {
            try {
                const urls = [
                    'https://zfbht.huiwu0811.com/system/config/configKey/alipay.appId'
                ]

                for (const url of urls) {
                    try {
                        const resp = await fetch(url, { method: 'GET' })
                        const data = await resp.json()
                        const appId = data && data.data
                        if (resp.ok && appId) {
                            this.alipayAppId = appId
                            return
                        }
                    } catch (e) {
                        // try next url
                    }
                }
            } catch (error) {
                console.error('获取支付宝 appId 失败', error)
            }
        },
        getDefaultAlipayAppIdByDomain() {
            const domain = window.location.hostname
            const appIdMap = {
                'vip.winihao.top': '2021006162661316',
                'vip.dingxindun.com': '2021006162625180',
                'vip.xinghuilg.com': '2021006162645006',
                'zfbvip.yingsi0221.com': '2021006104667544',
                'vip.yzxh01.com': '2021006135640943'
            }
            return appIdMap[domain] || '2021006135640943'
        },
        getAlipayJumpUrl() {
            const appId = this.alipayAppId && String(this.alipayAppId).trim()
                ? this.alipayAppId
                : this.getDefaultAlipayAppIdByDomain()
            return `alipays://platformapi/startapp?appId=${appId}`
        },
        onOpen() {
            if (!/^1\d{10}$/.test(this.mobile)) {
                this.$message.warning('请输入正确的手机号');
                return;
            }

            window.location.href = this.getAlipayJumpUrl()
        },
        openRulePage() {
            this.$router.push('/rule-page')
        }
    }
}
</script>

<style scoped>
.page-wrap {
    min-height: 100vh;
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background: #ef612f;
}
.landing-shell {
    min-height: 100vh;
    padding: 0 0 28px;
    box-sizing: border-box;
}
.hero-img {
    width: 100%;
    display: block;
}
.consent-block {
    margin: 0 12px;
    margin-top: 0;
    padding-top: 6px;
}
.step-label {
    width: 152px;
    display: block;
    margin: 0 0 8px 22px;
}
.phone-input-wrap {
    padding: 18px 20px;
    border-radius: 999px;
    background: #fff;
    margin: 0 0 8px;
}
.phone-input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 18px;
    color: #333;
}
.phone-input::placeholder {
    color: #9d9d9d;
}
.agree-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #d6c58b;
    font-size: 12px;
    line-height: 1.2;
    margin-top: 4px;
    text-align: center;
}
.agree-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #d8c88a;
    color: #fff;
    font-size: 12px;
    flex-shrink: 0;
}
.rule-link {
    border: none;
    background: transparent;
    padding: 0;
    color: inherit;
    font: inherit;
    text-decoration: none;
}
.confirm-btn {
    width: calc(100% - 24px);
    border: none;
    background: transparent;
    padding: 0;
    display: block;
    margin: 22px auto 0;
}
.confirm-btn-fixed {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    z-index: 20;
    max-width: calc(100% - 24px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    opacity: 1;
}
.confirm-btn-bottom {
    margin: 28px auto 0;
}
.confirm-gif {
    width: 100%;
    display: block;
}
.confirm-spacer {
    height: 4px;
}
.price-line {
    position: absolute;
    left: 50%;
    top: 6px;
    transform: translateX(-50%);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.2px;
    white-space: nowrap;
    background: linear-gradient(180deg, #fff6d8 0%, #f4d27a 45%, #d5ab53 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}
.below-content {
    margin-top: 18px;
    padding: 0 12px 30px;
}
.benefits-wrap {
    position: relative;
}
.benefits-image {
    width: 100%;
    display: block;
    border-radius: 18px;
    box-shadow: 0 10px 22px rgba(0,0,0,0.08);
}
.section-title {
    margin: 18px 2px 10px;
    font-size: 18px;
    font-weight: 900;
    color: #fff;
}
.rules-banner {
    position: relative;
    margin-top: 14px;
    border-radius: 18px;
    overflow: hidden;
}
.rules-banner-img {
    width: 100%;
    display: block;
}
.rules-banner-text {
    position: absolute;
    inset: 0;
    padding: 80px 14px 16px;
    box-sizing: border-box;
    overflow-y: auto;
}
.rules-copy {
    color: #4a2a16;
    line-height: 1.78;
    font-size: 12px;
}
.rules-copy p {
    margin: 0 0 12px;
}
.rules-copy p:first-child {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 14px;
}
.rules-copy p:nth-child(3),
.rules-copy p:nth-child(10),
.rules-copy p:nth-child(14) {
    margin-top: 8px;
}
.footer-note {
    margin-top: 16px;
    padding: 16px 14px 10px;
    text-align: center;
    color: rgba(255,255,255,0.86);
    font-size: 12px;
    line-height: 1.8;
}
.notice-strip {
    margin-top: 14px;
    padding: 14px 14px;
    border-radius: 18px;
    background: linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.08));
    color: #fff;
    text-align: center;
    line-height: 1.7;
}
.notice-strip .notice-title {
    font-size: 18px;
    font-weight: 900;
}
.notice-strip .notice-desc {
    margin-top: 6px;
    font-size: 13px;
    opacity: 0.92;
}
.faq-list {
    display: grid;
    gap: 12px;
}
.faq-item {
    border-radius: 18px;
    padding: 14px;
    background: rgba(255,255,255,0.95);
    color: #333;
    box-shadow: 0 10px 22px rgba(0,0,0,0.08);
}
.faq-q {
    font-weight: 800;
    color: #111;
    margin-bottom: 8px;
}
.faq-a {
    font-size: 13px;
    line-height: 1.65;
    color: #555;
}
.footer-note {
    margin-top: 16px;
    padding: 16px 14px 10px;
    text-align: center;
    color: rgba(255,255,255,0.86);
    font-size: 12px;
    line-height: 1.8;
}
.dialog-content {
    text-align: center;
    line-height: 1.8;
    color: #444;
}
.dialog-footer { display: block; text-align: center; }
</style>
